var _rect, _path, _path2, _rect2, _rect3, _circle, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 56,
    viewBox: "0 0 49 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 2,
    width: 31,
    height: 43,
    fill: "#7DA9E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0003 0C37.4003 0 38.0005 0.5 39.0003 2C40.0001 3.5 4.78005 15.6461 4.00027 2C3.95571 1.22022 4.00027 0 4.00027 0H35.0003Z",
    fill: "#7DA9E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0C6.20914 0 8 1.79086 8 4V10H0V4Z",
    fill: "#2F75DA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 15,
    width: 22,
    height: 4,
    rx: 2,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 25,
    width: 16,
    height: 4,
    rx: 2,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 43,
    r: 13,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.333 48.875V47.4583C40.333 46.7069 40.0345 45.9862 39.5031 45.4549C38.9718 44.9235 38.2511 44.625 37.4997 44.625H32.5413C31.7899 44.625 31.0692 44.9235 30.5379 45.4549C30.0065 45.9862 29.708 46.7069 29.708 47.4583V48.875M41.0413 41.7917L42.458 43.2083L45.2913 40.375M37.8538 38.9583C37.8538 40.5231 36.5853 41.7917 35.0205 41.7917C33.4557 41.7917 32.1872 40.5231 32.1872 38.9583C32.1872 37.3935 33.4557 36.125 35.0205 36.125C36.5853 36.125 37.8538 37.3935 37.8538 38.9583Z",
    stroke: "#2F75DA",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.576e143581183ef70be738d30d5a0f51.svg";
export { ForwardRef as ReactComponent };